const BASE_HEIGHT = 50;
const REMAINING_HEIGHT = 50;
const MAX_HEIGHT = 105;

export const getChartHeights = (value1: number, value2: number) => {
  const calculateHeight = (value: number) => {
    if (value === 0) return 0;

    const proportionalHeight = (value / REMAINING_HEIGHT) * 100;
    return Math.min(BASE_HEIGHT + proportionalHeight, MAX_HEIGHT);
  };

  const height1 = calculateHeight(value1);
  const height2 = calculateHeight(value2);

  return { height1, height2 };
};
